import React from 'react';
import {
  Stack,
  Text,
  Icon,
  withTranslation,
  Badge,
} from '@piwikpro/ui-components';
import { TFunction } from 'react-i18next';
import { CookieInformationAccount } from '../../CookieInformationService';

interface CookieInformationAccountPreviewProps {
  accountName: CookieInformationAccount['accountName']
  inModal: boolean
  t: TFunction
}

export const CookieInformationAccountPreview: React.FC<CookieInformationAccountPreviewProps> = ({ accountName, inModal, t }) => (
  <Stack verticalAlignment="center" vertical={inModal} spacing="extraNarrow">
    <Stack.Item fill>
      <Stack verticalAlignment="center" spacing="extraNarrow">
        <Stack.Item>
          <Text as="p" weight={600} dataId="Label">{accountName}</Text>
        </Stack.Item>
        <Stack.Item>
          <Badge size="medium" text={t('cookieInformation.preview.addedBadge')} color="light-green" />
        </Stack.Item>
      </Stack>
    </Stack.Item>
    <Stack.Item>
      <Stack verticalAlignment="center" spacing="extraNarrow">
        <Stack.Item>
          <Icon name="info-circle" size="small" color="blue" />
        </Stack.Item>
        <Stack.Item>
          <Text as="p" size={12} color="InkLighter" dataId="Caption">
            {t('cookieInformation.preview.infoText')}
          </Text>
        </Stack.Item>
      </Stack>
    </Stack.Item>
  </Stack>
);

export default withTranslation(['administration'])(CookieInformationAccountPreview);
